import React, { useState, useEffect } from "react";
import Header from "./Header";
import VertNav from "./VertNav";
import PurchaseModal from "./PurchaseModal.jsx";
import config from "../../config.js";

const PurchasesManagement = () => {
    const [purchasesData, setPurchasesData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const purchasesPerPage = 15;
    const bid = localStorage.getItem("branch_id");

    const [selectedMonth, setSelectedMonth] = useState(
        new Date().getMonth() + 1
    );
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [showModal, setShowModal] = useState(false);

    const calculateTotal = (products) => {
        if (!products || !products.length) return "0";
        return products
            .reduce((total, product) => {
                return (
                    total +
                    product.quantity * product.rate * (1 + product.gst / 100)
                );
            }, 0)
            .toFixed(2);
    };

    const years = React.useMemo(() => {
        if (!purchasesData || !purchasesData.length) {
            const currentYear = new Date().getFullYear();
            return [currentYear - 1, currentYear, currentYear + 1];
        }
        return [
            ...new Set(
                purchasesData
                    .filter((purchase) => purchase && purchase.uploaded_at)
                    .map((purchase) => {
                        const dateParts = purchase.uploaded_at.split("-");
                        return parseInt(dateParts[0]);
                    })
            ),
        ].sort((a, b) => b - a);
    }, [purchasesData]);

    useEffect(() => {
        fetchPurchases();
    }, [bid]);

    const fetchPurchases = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `${config.apiUrl}/api/swalook/vendor-expense-purchase/?branch_name=${bid}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            if (!response.ok) throw new Error("Failed to fetch purchases");

            const result = await response.json();

            if (result.status) {
                const validData = result.data
                    ? result.data.filter(
                          (item) => item !== null && item !== undefined
                      )
                    : [];
                setPurchasesData(validData);
                setFilteredData(validData);
            } else {
                throw new Error(result.message || "Invalid response");
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    // useEffect(() => {
    //     const fetchPurchases = async () => {
    //         try {
    //             const token = localStorage.getItem("token");
    //             const response = await fetch(
    //                 `${config.apiUrl}/api/swalook/vendor-expense-purchase/?branch_name=${bid}`,
    //                 {
    //                     headers: {
    //                         "Content-Type": "application/json",
    //                         Authorization: `Token ${token}`,
    //                     },
    //                 }
    //             );

    //             if (!response.ok) throw new Error("Failed to fetch purchases");

    //             const result = await response.json();

    //             if (result.status) {
    //                 const validData = result.data
    //                     ? result.data.filter(
    //                           (item) => item !== null && item !== undefined
    //                       )
    //                     : [];
    //                 setPurchasesData(validData);
    //                 setFilteredData(validData);
    //             } else {
    //                 throw new Error(result.message || "Invalid response");
    //             }
    //         } catch (error) {
    //             setError(error.message);
    //         } finally {
    //             setIsLoading(false);
    //         }
    //     };
    //     fetchPurchases();
    // }, [bid]);

    useEffect(() => {
        if (!Array.isArray(purchasesData)) {
            setFilteredData([]);
            return;
        }

        const filtered = purchasesData.filter((purchase) => {
            if (!purchase || !purchase.uploaded_at) return false;
            try {
                const date = new Date(purchase.uploaded_at);
                return (
                    date.getMonth() + 1 === selectedMonth &&
                    date.getFullYear() === selectedYear
                );
            } catch (e) {
                return false;
            }
        });

        setFilteredData(filtered);
        setCurrentPage(1);
    }, [selectedMonth, selectedYear, purchasesData]);

    const indexOfLastPurchase = currentPage * purchasesPerPage;
    const indexOfFirstPurchase = indexOfLastPurchase - purchasesPerPage;
    const currentPurchases = filteredData.slice(
        indexOfFirstPurchase,
        indexOfLastPurchase
    );

    const totalPages = Math.ceil(filteredData.length / purchasesPerPage);
    const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handlePageChange = (pageNum) => {
        setCurrentPage(pageNum);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return "Invalid Date";
            return `${date.getDate().toString().padStart(2, "0")}/${(
                date.getMonth() + 1
            )
                .toString()
                .padStart(2, "0")}/${date.getFullYear().toString().slice(-2)}`;
        } catch (e) {
            return "Invalid Date";
        }
    };

    return (
        <>
            <VertNav />
            <Header />
            <div className="flex min-h-screen bg-gray-50">
                <div className="flex-grow md:ml-72 lg:ml-72 p-4 md:p-6 lg:p-10 overflow-auto">
                    <div className="bg-white rounded-3xl shadow-md p-8">
                        <div className="md:flex justify-between items-center mb-8">
                            <h2 className="text-2xl font-semibold text-gray-800">
                                Purchases
                            </h2>
                            <div className="flex items-center gap-4">
                                <div className="flex items-center gap-2">
                                    <label
                                        htmlFor="month-filter"
                                        className="text-gray-500"
                                    >
                                        Filter:
                                    </label>
                                    <select
                                        id="month-filter"
                                        className="px-3 py-2 border border-gray-300 rounded-full"
                                        value={selectedMonth}
                                        onChange={(e) =>
                                            setSelectedMonth(
                                                parseInt(e.target.value)
                                            )
                                        }
                                    >
                                        {Array.from({ length: 12 }, (_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {new Date(0, i).toLocaleString(
                                                    "default",
                                                    { month: "long" }
                                                )}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        id="year-filter"
                                        className="px-3 py-2 border border-gray-300 rounded-full"
                                        value={selectedYear}
                                        onChange={(e) =>
                                            setSelectedYear(
                                                parseInt(e.target.value)
                                            )
                                        }
                                    >
                                        {years.map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <button
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full transition-colors"
                                    onClick={() => setShowModal(true)}
                                >
                                    + New Purchase
                                </button>
                            </div>
                        </div>

                        {isLoading ? (
                            <div className="flex justify-center items-center h-64">
                                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
                            </div>
                        ) : error ? (
                            <div className="text-red-500 text-center p-8">
                                Error: {error}
                            </div>
                        ) : (
                            <>
                                <div className="overflow-x-auto rounded-[2.5rem] border border-gray-200">
                                    <table className="w-full">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    S. No.
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Date
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Vendor
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Invoice ID
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Total Amount
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Amount Paid
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                    Completed Date
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {currentPurchases.length > 0 ? (
                                                currentPurchases.map(
                                                    (purchase, index) =>
                                                        purchase ? (
                                                            <tr
                                                                key={
                                                                    purchase.id ||
                                                                    index
                                                                }
                                                                className="hover:bg-gray-50"
                                                            >
                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                    {indexOfFirstPurchase +
                                                                        index +
                                                                        1}
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                    {formatDate(
                                                                        purchase.uploaded_at
                                                                    )}
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                    {purchase
                                                                        .vendor
                                                                        ?.vendor_name ||
                                                                        "N/A"}
                                                                </td>

                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                    {purchase.invoice_id ||
                                                                        "N/A"}
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                    ₹
                                                                    {calculateTotal(
                                                                        purchase.products
                                                                    )}
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                    ₹
                                                                    {purchase.amount_paid ||
                                                                        "0"}
                                                                </td>
                                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                                    {formatDate(
                                                                        purchase.completed_date
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ) : null
                                                )
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="7"
                                                        className="px-6 py-4 text-center text-gray-500"
                                                    >
                                                        No purchases found for
                                                        selected period
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="flex flex-col sm:flex-row justify-between items-center mt-6">
                                    <span className="text-sm text-gray-500 mb-4 sm:mb-0">
                                        Showing data {indexOfFirstPurchase + 1}{" "}
                                        to{" "}
                                        {Math.min(
                                            indexOfLastPurchase,
                                            filteredData.length
                                        )}{" "}
                                        of {filteredData.length} entries
                                    </span>

                                    {totalPages > 1 && (
                                        <div className="flex gap-2">
                                            <button
                                                className="px-3 py-1 rounded-full bg-gray-200 disabled:opacity-50"
                                                disabled={currentPage === 1}
                                                onClick={() =>
                                                    handlePageChange(
                                                        currentPage - 1
                                                    )
                                                }
                                            >
                                                &lt;
                                            </button>

                                            {pageNumbers
                                                .slice(
                                                    Math.max(
                                                        0,
                                                        currentPage - 3
                                                    ),
                                                    Math.min(
                                                        totalPages,
                                                        currentPage + 2
                                                    )
                                                )
                                                .map((number) => (
                                                    <button
                                                        key={number}
                                                        className={`px-3 py-1 rounded-full ${
                                                            number ===
                                                            currentPage
                                                                ? "bg-blue-500 text-white"
                                                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                                        }`}
                                                        onClick={() =>
                                                            handlePageChange(
                                                                number
                                                            )
                                                        }
                                                    >
                                                        {number}
                                                    </button>
                                                ))}

                                            <button
                                                className="px-3 py-1 rounded-full bg-gray-200 disabled:opacity-50"
                                                disabled={
                                                    currentPage === totalPages
                                                }
                                                onClick={() =>
                                                    handlePageChange(
                                                        currentPage + 1
                                                    )
                                                }
                                            >
                                                &gt;
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
                {showModal && (
                    <PurchaseModal
                        onClose={() => setShowModal(false)}
                        onPurchaseAdded={() => {
                            fetchPurchases();
                            setShowModal(false);
                        }}
                    />
                )}
            </div>
        </>
    );
};

export default PurchasesManagement;
